// 获取图片的宽度和高度
export function getImageWidthAndHeight(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = url;
    img.onload = () => {
      resolve({ width: img.width, height: img.height });
    };
    img.onerror = reject;
  });
}

// 获取视频的宽度和高度
export function getVideoWidthAndHeight(url) {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.src = url;
    video.preload = 'metadata';
    video.onloadedmetadata = () => {
      resolve({ width: video.videoWidth, height: video.videoHeight });
    };
    video.onerror = reject;
  });
}

// 使用Date对象将时间戳转换为年、月、日、时、分的格式。下面是一个函数示例，它接受一个Unix时间戳（以毫秒为单位）并返回一个格式化的日期字符串。
export function timestampToDateTime(endTime) {
  let date = new Date(endTime);
  let Y = date.getFullYear();
    let M = ("0" + (date.getMonth() + 1)).slice(-2);
    let D = ("0" + date.getDate()).slice(-2);

    let h = ("0" + date.getHours()).slice(-2);
    let m = ("0" + date.getMinutes()).slice(-2);
    let s = ("0" + date.getSeconds()).slice(-2);

    return `${Y}-${M}-${D} ${h}:${m}`;
}